/**
 * Punto de entrada. Lee la configuración de runtime y solo entonces arranca.
 *
 * El `import()` DINÁMICO no es estilo: es lo único que ordena las dos cosas.
 * Los imports estáticos de un módulo se evalúan antes de su primera sentencia,
 * y el árbol de `./arranque` llega hasta `@/api`, donde el `BASE` de `http.ts`
 * y el `api` de `api/index.ts` quedan congelados en tiempo de evaluación. Un
 * `await fetch()` escrito aquí arriba llegaría tarde igual.
 *
 * Un módulo de configuración con `await` de nivel superior tampoco valdría por
 * sí solo: cuando una dependencia del grafo es asíncrona, las hermanas se
 * siguen evaluando de forma síncrona, así que `App.vue` se ejecutaría antes de
 * que resolviera el `fetch`. Habría que hacer que `http.ts` y `api/index.ts`
 * importaran ese módulo —para ser dependientes suyos— y subir `build.target`,
 * porque el objetivo por defecto de Vite no admite `await` de nivel superior y
 * Rollup aborta la compilación.
 *
 * Los estilos SÍ se quedan aquí, en el módulo de entrada, y a propósito: así
 * Vite los emite como un `<link>` del `index.html` en vez de dentro del chunk
 * diferido, y la página no aparece un instante sin estilos mientras se resuelve
 * la configuración.
 */

import '@/styles/lcd.css'
import '@/styles/base.css'
import '@/styles/ascii.css'

import { cargarConfig } from './config/runtime'

void cargarConfig()
  .then(() => import('./arranque'))
  .then((m) => m.arrancar())
